module.exports = __webpack_public_path__ + "static/supports-69eb4fee555f30a5c179dbf659cde5ca.png";